import { GMXExpandTileBase } from '../expand-tile-base/expand-tile-base'
import { dispatchGbaalLinkClickEvent } from '../../../../utils/dispatchGbaalLinkClickEvent'

/**
 * Tile - Toggle Tile
 */
export class GMXToggleTile extends GMXExpandTileBase {
	imageContainerEl: HTMLElement
	toggleBtn: HTMLButtonElement
	collapsedContentContainerEl: HTMLElement
	parentToggleTileEl: GMXToggleTile
	nestedToggleTileEl: GMXToggleTile

	private boundToggleBtnClickHandler = this._handleToggleBtnClick.bind(this)

	get mode(): string {
		return this.getAttribute('data-mode')
	}

	set mode(mode: string) {
		this.setAttribute('data-mode', mode)
	}

	connectedCallback(): void {
		super.connectedCallback()

		this.imageContainerEl = this.querySelector('.img-container')
		this.toggleBtn = this.querySelector('.toggle-btn')
		this.collapsedContentContainerEl = this.querySelector('.collapsed-content-container')
		this.nestedToggleTileEl = this.querySelector('gmx-toggle-tile')
		this.parentToggleTileEl = this.parentElement?.closest('gmx-toggle-tile')
		if (this.toggleBtn) {
			this.toggleBtn.addEventListener('click', this.boundToggleBtnClickHandler)
		}

		if (!this.mode) {
			this.mode = 'light'
			this.collapsedContentContainerEl?.classList.remove('gmx-invert')
		}
	}

	disconnectedCallback(): void {
		if (this.toggleBtn) {
			this.toggleBtn.removeEventListener('click', this.boundToggleBtnClickHandler)
		}
	}

	private _handleToggleBtnClick(e: Event): void {
		e.stopPropagation()
		this.mode = this.mode === 'light' ? 'dark' : 'light'

		this.nestedToggleTileEl?.setAttribute('data-mode', this.mode)
		this.nestedToggleTileEl?.classList.toggle('gmx-invert', this.mode === 'dark')
		this.parentToggleTileEl?.setAttribute('data-mode', this.mode)
		this.parentToggleTileEl?.querySelector('.collapsed-content-container')?.classList.toggle('gmx-invert', this.mode === 'dark')

		if (this.mode === 'dark') {
			this.collapsedContentContainerEl?.classList.add('gmx-invert')
			// Toggle the invert class on the component if it's by itself (no expand option)
			this.classList.toggle('gmx-invert', !this.classList.contains('gmx-expand-tile-base'))
		} else {
			this.classList.remove('gmx-invert')
			this.collapsedContentContainerEl?.classList.remove('gmx-invert')
		}

		if (e.currentTarget instanceof Element) {
			// Use currentTarget (not target) so nested markup inside the button (e.g. an
			// icon) doesn't get passed to GBAAL instead of the button itself.
			// `value` reflects the post-toggle mode (this.mode was already flipped above).
			dispatchGbaalLinkClickEvent(this, e.currentTarget, { value: this.mode, interactionType: 'click' })
		}
	}

	handleExpandBtnClicked(e: Event): void {
		super.handleExpandBtnClicked(e)
	}
}
if (!customElements.get('gmx-toggle-tile')) {
	customElements.define('gmx-toggle-tile', GMXToggleTile)
}
